module.exports = __webpack_public_path__ + "82bf54a03ef84abe26ca16e2714c2986.svg";